import type { ProgramsFilterSelections, ProgramsSortSelection, StateTree } from '@makemydeal/dr-dash-types';
import type { OfferType } from '@makemydeal/dr-platform-types';

export const getProgramsFilterPreferences = (state: StateTree, offerType?: OfferType): ProgramsFilterSelections | undefined =>
    offerType ? state.programsPreferences?.stickyFiltersAndSort?.[offerType]?.filters : undefined;

export const getProgramsSortPreference = (state: StateTree, offerType?: OfferType): ProgramsSortSelection | null =>
    (offerType ? state.programsPreferences?.stickyFiltersAndSort?.[offerType]?.sort : undefined) ?? null;
